import { render } from "./BibleHint.vue?vue&type=template&id=a40f4004"
import script from "./BibleHint.vue?vue&type=script&lang=js"
export * from "./BibleHint.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__